import { render, staticRenderFns } from "./HeaderMobilePage.vue?vue&type=template&id=28d1ef14&scoped=true&"
import script from "./HeaderMobilePage.vue?vue&type=script&lang=js&"
export * from "./HeaderMobilePage.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMobilePage.vue?vue&type=style&index=0&id=28d1ef14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d1ef14",
  null
  
)

export default component.exports